import * as React from "react";
import styles from "./Notification.module.scss";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import infoIcon from "../../assets/info-circle.svg";
import crossIcon from "../../assets/cross.svg";
import version from "../../utils/versionChangeLog.json";
import { t } from "i18next";

const versionData = (version.at(0)?.major ?? 0) + "." + (version.at(0)?.minor ?? 0);

const versionDataLink = (value: string) => {
  if (value.includes("?") || value.includes("&")) {
    return value + "&versionNotice=" + versionData;
  } else {
    return value + "?versionNotice=" + versionData;
  }
};

function showVersionNoticeNote(): boolean {
  const lastSeenVersion = localStorage.getItem("lastSeenVersion");

  if (versionData != lastSeenVersion) {
    return true;
  } else {
    return false;
  }
}

const ShowInformationPopup: React.FC = () => {
  const [showVersionNotes, setShowNotification] = React.useState(() => showVersionNoticeNote());

  function hideVersionNoteNotification() {
    setShowNotification(false);
    localStorage.setItem("lastSeenVersion", versionData);
  }

  if (showVersionNotes == true) {
    return (
      <div className={styles.NotificationHeader}>
        <div className={styles.NotificationIcon}>
          <img alt="Icon" src={infoIcon} />
        </div>
        <div className={styles.NotificationHeaderText}>
          <p>{t("Fault Viewer version") + " " + versionData + " " + t("released")}.</p>
          <p className={styles.NotificationHeaderTextLink}>
            <Link to={versionDataLink(useLocation().search)}>{t("Read more")}</Link>
          </p>
        </div>
        <div className={styles.NotificationExitButton}>
          <img alt="Cross" src={crossIcon} onClick={hideVersionNoteNotification} />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default ShowInformationPopup;
